export const bulkUploadConfigs = {
  author: {
    key: 'author',
    title: 'Authors Bulk Upload',
    label: 'Author',
    backPath: '/authors',
    fieldLabels: {
      name: 'kolom "name" (Nama)',
      email: 'Email',
      phone: 'No HP',
      biography: 'Biografi Bahasa Indonesia',
      biography_tl: 'Biografi Bahasa Inggris',
      awards: 'Penghargaan',
      facebook: 'link Facebook',
      instagram: 'link Instagram',
      tiktok: 'link TikTok',
      twitter: 'link Twitter',
      youtube: 'link YouTube',
      website_url: 'link Website',
      profile_picture: 'link Foto Profil',
      image_credit: 'Kredit Gambar',
      is_draft: 'kolom "is_draft"',
      meta_title: 'Meta Title',
      meta_description: 'Meta Description',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama penulis dan tidak boleh kosong.',
      email: 'Harusnya ditulis dengan format email yang valid, contoh: nama@example.com.',
      phone: 'Harusnya diawali kode negara tanpa spasi, contoh: +628123456789.',
      facebook: 'Harusnya dimulai dengan http:// atau https://.',
      instagram: 'Harusnya dimulai dengan http:// atau https://.',
      tiktok: 'Harusnya dimulai dengan http:// atau https://.',
      twitter: 'Harusnya dimulai dengan http:// atau https://.',
      youtube: 'Harusnya dimulai dengan http:// atau https://.',
      website_url: 'Harusnya dimulai dengan http:// atau https://.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      meta_title: 'Harusnya berupa teks judul halaman.',
      meta_description: 'Harusnya berupa teks deskripsi halaman.',
    },
  },
  book: {
    key: 'book',
    title: 'Books Bulk Upload',
    label: 'Book',
    backPath: '/books',
    fieldLabels: {
      title: 'kolom "title" (Judul Bahasa Indonesia)',
      title_tl: 'kolom "title_tl" (Judul Bahasa Inggris)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
      image_cover: 'kolom "image_cover" (Link Sampul Buku)',
      image_credit: 'kolom "image_credit" (Kredit Gambar)',
      isbn: 'kolom "isbn" (ISBN)',
      total_page: 'kolom "total_page" (Jumlah Halaman)',
      initial_language: 'kolom "initial_language" (Bahasa Asal)',
      translation_rights: 'kolom "translation_rights" (Hak Terjemahan)',
      translation_rights_tl: 'kolom "translation_rights_tl" (Hak Terjemahan Bahasa Inggris)',
      contact_person_name: 'kolom "contact_person_name" (Nama Kontak)',
      contact_person_email: 'kolom "contact_person_email" (Email Kontak)',
      release_date: 'kolom "release_date" (Tanggal Rilis)',
      available_languages: 'kolom "available_languages" (Bahasa Tersedia)',
      publisher_name: 'kolom "publisher_name" (Nama Penerbit)',
      illustrator_name: 'kolom "illustrator_name" (Nama Ilustrator)',
      translator_name: 'kolom "translator_name" (Nama Penerjemah)',
      literary_agency_name: 'kolom "literary_agency_name" (Nama Agen Literer)',
      author_names: 'kolom "author_names" (Nama Penulis)',
      category_names: 'kolom "category_names" (Nama Kategori)',
      sub_category_names: 'kolom "sub_category_names" (Nama Sub Kategori)',
      highlight: 'kolom "highlight"',
      is_draft: 'kolom "is_draft"',
      meta_title: 'kolom "meta_title"',
      meta_description: 'kolom "meta_description"',
    },
    fieldFixes: {
      title: 'Harusnya diisi judul buku dan tidak boleh kosong.',
      title_tl: 'Harusnya diisi judul buku dalam bahasa Inggris.',
      description: 'Harusnya diisi deskripsi buku dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi buku dalam bahasa Inggris.',
      image_cover: 'Harusnya dimulai dengan http:// atau https://.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      isbn: 'Harusnya berupa nomor ISBN buku.',
      total_page: 'Harusnya berupa angka, contoh: 200.',
      initial_language: 'Harusnya berupa bahasa asal buku.',
      translation_rights: 'Harusnya berupa informasi hak terjemahan.',
      contact_person_name: 'Harusnya diisi nama kontak penerbit.',
      contact_person_email: 'Harusnya berupa email kontak yang valid.',
      release_date: 'Harusnya dalam format YYYY, contoh: 2026.',
      available_languages: 'Harusnya berupa daftar bahasa, contoh: Indonesia, Inggris.',
      publisher_name: 'Harusnya nama penerbit yang sudah ada di database.',
      illustrator_name: 'Harusnya nama ilustrator yang sudah ada di database.',
      translator_name: 'Harusnya nama penerjemah yang sudah ada di database.',
      literary_agency_name: 'Harusnya nama agen literer yang sudah ada di database.',
      author_names: 'Harusnya nama penulis yang sudah ada di database, pisahkan dengan titik koma (;).',
      category_names: 'Harusnya nama kategori yang sudah ada di database, pisahkan dengan titik koma (;).',
      sub_category_names: 'Harusnya nama sub kategori yang sudah ada di database, pisahkan dengan titik koma (;).',
      highlight: 'Harusnya diisi TRUE atau FALSE.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
      meta_title: 'Harusnya berupa teks meta title.',
      meta_description: 'Harusnya berupa teks meta description.',
    },
  },
  news: {
    key: 'news',
    title: 'News Bulk Upload',
    label: 'News',
    backPath: '/news',
    fieldLabels: {
      title: 'kolom "title" (Judul Bahasa Indonesia)',
      title_tl: 'kolom "title_tl" (Judul Bahasa Inggris)',
      body: 'kolom "body" (Isi Berita Bahasa Indonesia)',
      body_tl: 'kolom "body_tl" (Isi Berita Bahasa Inggris)',
      summary: 'kolom "summary" (Ringkasan Bahasa Indonesia)',
      summary_tl: 'kolom "summary_tl" (Ringkasan Bahasa Inggris)',
      image_cover: 'kolom "image_cover" (Link Sampul Berita)',
      image_credit: 'kolom "image_credit" (Kredit Gambar)',
      video_url: 'kolom "video_url" (Link Video)',
      highlight: 'kolom "highlight"',
      is_draft: 'kolom "is_draft"',
      meta_title: 'kolom "meta_title"',
      meta_description: 'kolom "meta_description"',
    },
    fieldFixes: {
      title: 'Harusnya diisi judul berita dan tidak boleh kosong.',
      title_tl: 'Harusnya diisi judul berita dalam bahasa Inggris.',
      body: 'Harusnya diisi isi berita dalam bahasa Indonesia.',
      body_tl: 'Harusnya diisi isi berita dalam bahasa Inggris.',
      summary: 'Harusnya diisi ringkasan berita dalam bahasa Indonesia.',
      summary_tl: 'Harusnya diisi ringkasan berita dalam bahasa Inggris.',
      image_cover: 'Harusnya dimulai dengan http:// atau https://.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      highlight: 'Harusnya diisi TRUE atau FALSE.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
      meta_title: 'Harusnya berupa teks meta title.',
      meta_description: 'Harusnya berupa teks meta description.',
    },
  },
  media: {

    key: 'media',
    title: 'Medias Bulk Upload',
    label: 'Media',
    backPath: '/medias',
    fieldLabels: {
      title: 'kolom "title" (Judul)',
      title_tl: 'kolom "title_tl" (Judul Bahasa Inggris)',
      url: 'kolom "url" (Link Media)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
      thumbnail_image: 'kolom "thumbnail_image" (Link Thumbnail)',
      is_draft: 'kolom "is_draft"',
    },
    fieldFixes: {
      title: 'Harusnya diisi judul media dan tidak boleh kosong.',
      title_tl: 'Harusnya diisi judul media dalam bahasa Inggris.',
      url: 'Harusnya diisi link media dan dimulai dengan http:// atau https://.',
      description: 'Harusnya diisi deskripsi media dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi media dalam bahasa Inggris.',
      thumbnail_image: 'Harusnya dimulai dengan http:// atau https://.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
    },
  },
  publisher: {
    key: 'publisher',
    title: 'Publishers Bulk Upload',
    label: 'Publisher',
    backPath: '/publishers',
    fieldLabels: {
      name: 'kolom "name" (Nama Penerbit)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
      address: 'kolom "address" (Alamat)',
      phone: 'kolom "phone" (No HP)',
      email: 'kolom "email" (Email)',
      publisher_logo: 'kolom "publisher_logo" (Link Logo)',
      image_credit: 'kolom "image_credit" (Kredit Gambar)',
      facebook: 'link Facebook',
      instagram: 'link Instagram',
      tiktok: 'link TikTok',
      twitter: 'link Twitter',
      youtube: 'link YouTube',
      website_url: 'link Website',
      is_draft: 'kolom "is_draft"',
      meta_title: 'kolom "meta_title"',
      meta_description: 'kolom "meta_description"',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama penerbit dan tidak boleh kosong.',
      description: 'Harusnya diisi deskripsi penerbit dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi penerbit dalam bahasa Inggris.',
      address: 'Harusnya diisi alamat penerbit.',
      phone: 'Harusnya diawali kode negara tanpa spasi, contoh: +628123456789.',
      email: 'Harusnya ditulis dengan format email yang valid, contoh: nama@example.com.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      facebook: 'Harusnya dimulai dengan http:// atau https://.',
      instagram: 'Harusnya dimulai dengan http:// atau https://.',
      tiktok: 'Harusnya dimulai dengan http:// atau https://.',
      twitter: 'Harusnya dimulai dengan http:// atau https://.',
      youtube: 'Harusnya dimulai dengan http:// atau https://.',
      website_url: 'Harusnya dimulai dengan http:// atau https://.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
      meta_title: 'Harusnya berupa teks meta title.',
      meta_description: 'Harusnya berupa teks meta description.',
    },
  },
  illustrator: {
    key: 'illustrator',
    title: 'Illustrators Bulk Upload',
    label: 'Illustrator',
    backPath: '/illustrators',
    fieldLabels: {
      name: 'kolom "name" (Nama Ilustrator)',
      email: 'Email',
      phone_number: 'No HP',
      website_url: 'link Website',
      profile_picture: 'link Foto Profil',
      image_credit: 'Kredit Gambar',
      facebook: 'link Facebook',
      instagram: 'link Instagram',
      tiktok: 'link TikTok',
      twitter: 'link Twitter',
      youtube: 'link YouTube',
      biography: 'Biografi Bahasa Indonesia',
      biography_tl: 'Biografi Bahasa Inggris',
      is_draft: 'kolom "is_draft"',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama ilustrator dan tidak boleh kosong.',
      email: 'Harusnya ditulis dengan format email yang valid, contoh: nama@example.com.',
      phone_number: 'Harusnya diawali kode negara tanpa spasi, contoh: +628123456789.',
      website_url: 'Harusnya dimulai dengan http:// atau https://.',
      profile_picture: 'Harusnya dimulai dengan http:// atau https://.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      facebook: 'Harusnya dimulai dengan http:// atau https://.',
      instagram: 'Harusnya dimulai dengan http:// atau https://.',
      tiktok: 'Harusnya dimulai dengan http:// atau https://.',
      twitter: 'Harusnya dimulai dengan http:// atau https://.',
      youtube: 'Harusnya dimulai dengan http:// atau https://.',
      biography: 'Harusnya berupa biografi dalam bahasa Indonesia.',
      biography_tl: 'Harusnya berupa biografi dalam bahasa Inggris.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
    },
  },
  translator: {
    key: 'translator',
    title: 'Translators Bulk Upload',
    label: 'Translator',
    backPath: '/translators',
    fieldLabels: {
      name: 'kolom "name" (Nama Penerjemah)',
      email: 'Email',
      phone: 'No HP',
      website_url: 'link Website',
      profile_picture: 'link Foto Profil',
      image_credit: 'Kredit Gambar',
      facebook: 'link Facebook',
      instagram: 'link Instagram',
      tiktok: 'link TikTok',
      twitter: 'link Twitter',
      youtube: 'link YouTube',
      biography: 'Biografi Bahasa Indonesia',
      biography_tl: 'Biografi Bahasa Inggris',
      languages: 'Bahasa yang Dikuasai',
      is_draft: 'kolom "is_draft"',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama penerjemah dan tidak boleh kosong.',
      email: 'Harusnya ditulis dengan format email yang valid, contoh: nama@example.com.',
      phone: 'Harusnya diawali kode negara tanpa spasi, contoh: +628123456789.',
      website_url: 'Harusnya dimulai dengan http:// atau https://.',
      profile_picture: 'Harusnya dimulai dengan http:// atau https://.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      facebook: 'Harusnya dimulai dengan http:// atau https://.',
      instagram: 'Harusnya dimulai dengan http:// atau https://.',
      tiktok: 'Harusnya dimulai dengan http:// atau https://.',
      twitter: 'Harusnya dimulai dengan http:// atau https://.',
      youtube: 'Harusnya dimulai dengan http:// atau https://.',
      biography: 'Harusnya berupa biografi dalam bahasa Indonesia.',
      biography_tl: 'Harusnya berupa biografi dalam bahasa Inggris.',
      languages: 'Harusnya berupa daftar bahasa, contoh: Indonesia, Inggris.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
    },
  },
  literaryAgency: {
    key: 'literaryAgency',
    title: 'Literary Agencies Bulk Upload',
    label: 'Literary Agency',
    backPath: '/literary-agencies',
    fieldLabels: {
      name: 'kolom "name" (Nama Agen Literer)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
      address: 'kolom "address" (Alamat)',
      phone: 'kolom "phone" (No HP)',
      email: 'kolom "email" (Email)',
      agency_logo: 'kolom "agency_logo" (Link Logo)',
      image_credit: 'kolom "image_credit" (Kredit Gambar)',
      website_url: 'link Website',
      facebook: 'link Facebook',
      instagram: 'link Instagram',
      tiktok: 'link TikTok',
      twitter: 'link Twitter',
      youtube: 'link YouTube',
      is_draft: 'kolom "is_draft"',
      meta_title: 'kolom "meta_title"',
      meta_description: 'kolom "meta_description"',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama agen literer dan tidak boleh kosong.',
      description: 'Harusnya diisi deskripsi agen literer dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi agen literer dalam bahasa Inggris.',
      address: 'Harusnya diisi alamat agen literer.',
      phone: 'Harusnya diawali kode negara tanpa spasi, contoh: +628123456789.',
      email: 'Harusnya ditulis dengan format email yang valid, contoh: nama@example.com.',
      image_credit: 'Harusnya berupa teks kredit gambar.',
      website_url: 'Harusnya dimulai dengan http:// atau https://.',
      facebook: 'Harusnya dimulai dengan http:// atau https://.',
      instagram: 'Harusnya dimulai dengan http:// atau https://.',
      tiktok: 'Harusnya dimulai dengan http:// atau https://.',
      twitter: 'Harusnya dimulai dengan http:// atau https://.',
      youtube: 'Harusnya dimulai dengan http:// atau https://.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
      meta_title: 'Harusnya berupa teks meta title.',
      meta_description: 'Harusnya berupa teks meta description.',
    },
  },
  category: {
    key: 'category',
    title: 'Categories Bulk Upload',
    label: 'Category',
    backPath: '/categories',
    fieldLabels: {
      name: 'kolom "name" (Nama Kategori)',
      name_tl: 'kolom "name_tl" (Nama Bahasa Inggris)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama kategori dan tidak boleh kosong. Nama harus unik.',
      name_tl: 'Harusnya diisi nama kategori dalam bahasa Inggris.',
      description: 'Harusnya diisi deskripsi kategori dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi kategori dalam bahasa Inggris.',
    },
  },
  subCategory: {
    key: 'subCategory',
    title: 'Sub Categories Bulk Upload',
    label: 'Sub Category',
    backPath: '/sub-categories',
    fieldLabels: {
      name: 'kolom "name" (Nama Sub Kategori)',
      name_tl: 'kolom "name_tl" (Nama Bahasa Inggris)',
      description: 'kolom "description" (Deskripsi Bahasa Indonesia)',
      description_tl: 'kolom "description_tl" (Deskripsi Bahasa Inggris)',
      is_draft: 'kolom "is_draft"',
    },
    fieldFixes: {
      name: 'Harusnya diisi nama sub kategori dan tidak boleh kosong. Nama harus unik.',
      name_tl: 'Harusnya diisi nama sub kategori dalam bahasa Inggris.',
      description: 'Harusnya diisi deskripsi sub kategori dalam bahasa Indonesia.',
      description_tl: 'Harusnya diisi deskripsi sub kategori dalam bahasa Inggris.',
      is_draft: 'Harusnya diisi TRUE atau FALSE.',
    },
  },
};

export default bulkUploadConfigs;
